import { KPI_DASHBOARD_ROUTE_ID } from './common';

// Import directly instead of lazy loading to prevent full-page loader flash
import Dashboard from './components/Dashboard';

export default {
    [KPI_DASHBOARD_ROUTE_ID]: () => <Dashboard />
};
